import { IPartialTheme, IStyleSet } from "@fluentui/react/lib/Styling"
import { IStyleFunctionOrObject } from "@fluentui/react/lib/Utilities"

import { ISpinnerStyles } from "./Spinner.types"

export const SpinnerStyles: IStyleFunctionOrObject<
    IPartialTheme,
    IStyleSet<ISpinnerStyles>
> = () => ({})
